import { ThoughtspotPrivilegeGroup } from '@/api/generated/schemas';

export const SHARE_PERMISSION = {
  EDITOR: 'editor',
  VIEWER: 'viewer',
} as const;

// TODO: CLR-2 — 'owner' is a valid ThoughtSpot permission level but was omitted; add it here and update all consumers when backend contract is finalized
export type ShareAccessLevel = (typeof SHARE_PERMISSION)[keyof typeof SHARE_PERMISSION];

/** Whether a user's license tier permits the Editor (MODIFY) share level. */
export const canBeEditor = (userRole: ThoughtspotPrivilegeGroup | null): boolean =>
  userRole === ThoughtspotPrivilegeGroup.PRIV_CREATOR_USERS;

export interface ShareListItemData {
  id: string;
  name: string;
  email: string;
  sharedAsPermission: ShareAccessLevel;
  /**
   * License-level group, the only axis the share endpoint reports: PRIV_CREATOR_USERS,
   * PRIV_CONSUMER_USERS, or null. PRIV_ADVANCED_USERS/PRIV_STANDARD_USERS are in the
   * generated enum but are dashboard-level groups that never appear here — gate on
   * {@link canBeEditor}, never on a raw comparison.
   */
  userRole: ThoughtspotPrivilegeGroup | null;
  shareUnderlyingData: boolean;
  previouslyShared: boolean;
}
